import React from 'react';
import {Link} from 'react-router-dom'
import UnAuthorizedPage from './UnAuthorizedPage';
import UnAuthorizedHeader from '../components/UnAuthorizedHeader'
import ForgotPasswordFormContainer from '../containers/ForgotPasswordFormContainer';

const ForgotPage = () => (
    <UnAuthorizedPage>
        <UnAuthorizedHeader header="Forgot your password?" text="Please enter your email below and click the button. You will receive an email with further instructions." />
        <ForgotPasswordFormContainer />
        <Link to="/login">Back to login</Link>
    </UnAuthorizedPage>
);

export default ForgotPage;


// WEBPACK FOOTER //
// ./src/pages/ForgotPage.js